import { render } from "./Flex.vue?vue&type=template&id=24d79fa4&scoped=true&ts=true"
import script from "./Flex.vue?vue&type=script&lang=ts"
export * from "./Flex.vue?vue&type=script&lang=ts"

import "./Flex.vue?vue&type=style&index=0&id=24d79fa4&lang=scss&scoped=true"

import exportComponent from "/home/clients/feaac779814f31a1c015a97ecb52261b/sites/benefitme-website/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24d79fa4"]])

export default __exports__